// extracted by mini-css-extract-plugin
export default {"informacion-empresa":"ContactoAsuntosLegales_informacion-empresa__xOcNl"};